//@ts-nocheck

// Helper function to format WhatsApp number
export const formatWhatsAppNumber = (number = '') => {
  // Remove all non-numeric characters
  return number.replace(/\D/g, '');
};

// Helper function to open WhatsApp
export const openWhatsApp = (number = '') => {
  const formattedNumber = formatWhatsAppNumber(number);
  // Try to open native app first, fallback to web
  const whatsappUrl = `https://wa.me/${formattedNumber}`;
  window.open(whatsappUrl, '_blank');
};

// Helper function to open maps with address
export const openMaps = (address = '') => {
  const encodedAddress = encodeURIComponent(address);
  // Use Google Maps URL that works across platforms
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  window.open(mapsUrl, '_blank');
};

//copy to clipboard
export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};
